import React from 'react'
import Logo from '../../assets/images/Logo.png'
import { Link } from 'react-router-dom'
import FillablePdf from './FillablePdf'
import { useLocation } from 'react-router-dom';

function EditDocument() {
  const location = useLocation();
  const blobData = location.state && location.state.blobData;
  const xfdfString = location.state && location.state.xfdfString;
  return (
    <div className='container-fluid '>
              <FillablePdf blobData={blobData} xfdfString={xfdfString}/>
    </div>
  )
}

export default EditDocument